import axios from 'axios';
import { vmAddBannerElement } from './components';

const SEARCH_URL = '/tv/api/pickup_search';

const $elementArea = document.querySelector('.js-sidebar-tv');

window.addEventListener('DOMContentLoaded', () => {
  if ($elementArea !== null) {
    vmAddBannerElement.$mount('.js-sidebar-tv');
  }
});

const addSidebarTv = () => {
  function fetchSidebarTv () {
    axios({
      type: 'GET',
      timeout: 10000,
      crossDomain: true,
      dataType: 'json',
      headers: {
        'X-From': location.href
      },
      url: SEARCH_URL,
      data: {
        result: 1
      }
    }).then(res => {
      if (res.data[0]) {
        vmAddBannerElement.$data.isActive = true;
        res.data.forEach(data => {
          vmAddBannerElement.$data.value = data;
        });
      }
    });
  }

  function init () {
    fetchSidebarTv();
  }

  init();
};

window.addEventListener('DOMContentLoaded', () => {
  if ($elementArea !== null) {
    addSidebarTv();
  }
});
